import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Plus, Edit2, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function AdminBlogsList() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/blogs").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!confirm("Delete this blog?")) return;
    await api.delete(`/admin/blogs/${id}`);
    toast.success("Deleted"); load();
  };

  return (
    <div className="p-8">
      <div className="flex items-center justify-between">
        <h1 className="font-display font-black text-3xl" data-testid="blogs-title">Blogs</h1>
        <Link to="/admin/blogs/new" className="btn-primary-eq text-sm" data-testid="blogs-add"><Plus className="w-4 h-4" /> New Post</Link>
      </div>
      <div className="mt-6 bg-white rounded-2xl border border-neutral-200 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-neutral-50 text-neutral-500 text-xs uppercase tracking-wider">
            <tr><th className="text-left px-4 py-3">Title</th><th className="text-left px-4 py-3">Category</th><th className="text-left px-4 py-3">Author</th><th className="text-left px-4 py-3">Published</th><th className="text-left px-4 py-3">Actions</th></tr>
          </thead>
          <tbody>
            {items.map((b) => (
              <tr key={b.id} className="border-t border-neutral-100 hover:bg-neutral-50">
                <td className="px-4 py-3 font-semibold">{b.title}</td>
                <td className="px-4 py-3">{b.category}</td>
                <td className="px-4 py-3">{b.author}</td>
                <td className="px-4 py-3">{b.published ? "Yes" : "No"}</td>
                <td className="px-4 py-3 flex gap-2">
                  <Link to={`/admin/blogs/${b.id}`} className="p-1.5 hover:bg-neutral-100 rounded" data-testid={`blogs-edit-${b.id}`}><Edit2 className="w-4 h-4" /></Link>
                  <button onClick={() => remove(b.id)} className="p-1.5 hover:bg-red-100 text-red-600 rounded" data-testid={`blogs-delete-${b.id}`}><Trash2 className="w-4 h-4" /></button>
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={5} className="text-center py-16 text-neutral-500">No blogs yet. Click "New Post" to write your first article.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
